const initialState = {
  currentTheme: null,
};

const reducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {

    case 'SET_THEME': {
      return { ...state, currentTheme: action.payload.theme };
    }

    default:
      return state;

  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/common/themes/reducer.js